import { render, staticRenderFns } from "./WholesalersData.vue?vue&type=template&id=2f99a6bc&"
import script from "./WholesalersData.vue?vue&type=script&lang=js&"
export * from "./WholesalersData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports